"use strict";

export default class EventAddController
{
	/*@ngInject*/
	constructor($http, $state, $scope, $log, $translate, ValidationService, messageService)
	{
		//console.log("EventAddController");

		this.$http = $http;
		this.$state = $state;
		this.$log = $log;
		this.$translate = $translate;
		this.validation = new ValidationService();
		this.messageService = messageService;

		this.viewPromise = $http.post("/api/backend/events/neweventdata")
		.then(response =>
		{
			this.data = response.data;

			this.data.fromdateHours = new Date();
			this.data.fromdateHours.setHours(9, 0, 0, 0);
			this.data.todateHours = new Date();
			this.data.todateHours.setHours(18, 0, 0, 0);
			this.data.openinscriptionsHours = new Date();
			this.data.openinscriptionsHours.setHours(this.data.openinscriptionsHours.getHours(), 0, 0, 0);
			this.data.closeinscriptionsHours = new Date();
			this.data.closeinscriptionsHours.setHours(23, 59, 59, 999);
			this.data.allowremovinginscriptions = true;

			this.data.races = [{}];
		});
	}

	Add(form)
	{
		this.showError = false;

		if (!this.validation.checkFormValidity(form)) 
		{
			this.showError = true;
			return;
		}

		let ret = this.CollectEventData(this.data);
		if (ret == null) return;
		
		this.$http.post("/api/backend/events/add", ret)
		.then(response =>
		{
			this.$state.go("myevents");
		})
		.catch(err =>
		{
			this.$log.warn(err);
			this.messageService.Error(err.data);
		});
	}
}



// WEBPACK FOOTER //
// ./client/app/backend/events/event_add.controller.js